import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
import { FooterLogo } from './Logo';
import Subscribe from './Subscribe';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogoClick = () => {
        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            navigate('/');
            setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
        }
    };

    return (
        <footer className="bg-[#4A4E4D] text-white/80" data-testid="footer">
            <div className="container-wide mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Brand */}
                    <div className="space-y-6">
                        <button onClick={handleLogoClick} className="inline-block cursor-pointer">
                            <FooterLogo />
                        </button>
                        <p className="font-body text-sm leading-relaxed text-white/60">
                            Your trusted guide to discovering the finest spa and wellness experiences across India.
                        </p>
                        <div className="flex gap-4">
                            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-[#722F37] transition-colors" aria-label="Instagram">
                                <Instagram className="w-4 h-4" />
                            </a>
                            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-[#722F37] transition-colors" aria-label="Facebook">
                                <Facebook className="w-4 h-4" />
                            </a>
                            <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-[#722F37] transition-colors" aria-label="Twitter">
                                <Twitter className="w-4 h-4" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-heading text-lg text-white mb-6">Quick Links</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-sm text-white/70 hover:text-[#F5E1E4] transition-colors">Home</Link>
                            </li>
                            <li>
                                <Link to="/spas" className="text-sm text-white/70 hover:text-[#F5E1E4] transition-colors">Explore Spas</Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-sm text-white/70 hover:text-[#F5E1E4] transition-colors">About Us</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-sm text-white/70 hover:text-[#F5E1E4] transition-colors">Contact</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Spa Types */}
                    <div>
                        <h4 className="font-heading text-lg text-white mb-6">Spa Categories</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/spas?type=Luxury Spa" className="text-sm text-white/70 hover:text-[#C8A86B] transition-colors">Luxury Spas</Link>
                            </li>
                            <li>
                                <Link to="/spas?type=Day Spa" className="text-sm text-white/70 hover:text-[#C8A86B] transition-colors">Day Spas</Link>
                            </li>
                            <li>
                                <Link to="/spas?type=Ayurvedic Spa" className="text-sm text-white/70 hover:text-[#C8A86B] transition-colors">Ayurvedic Spas</Link>
                            </li>
                            <li>
                                <Link to="/spas?type=Thai Spa" className="text-sm text-white/70 hover:text-[#C8A86B] transition-colors">Thai Spas</Link>
                            </li>
                            <li>
                                <Link to="/spas?type=Wellness Spa" className="text-sm text-white/70 hover:text-[#C8A86B] transition-colors">Wellness Spas</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-heading text-lg text-white mb-6">Get in Touch</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                <MapPin className="w-5 h-5 text-[#C8A86B] flex-shrink-0 mt-0.5" />
                                <span className="text-sm">Bangalore, Karnataka, India</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-[#C8A86B] flex-shrink-0" />
                                <span className="text-sm">+91xxxxxxxxxx</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-[#C8A86B] flex-shrink-0" />
                                <span className="text-sm">info@thesapa.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-white/10">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-white/50">
                            &copy; {currentYear} SAPA. All rights reserved.
                        </p>
                        <div className="flex gap-6 text-sm text-white/50">
                            <Link to="/privacy-policy" className="hover:text-white/80 transition-colors">Privacy Policy</Link>
                            <Link to="/terms-of-service" className="hover:text-white/80 transition-colors">Terms of Service</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
